"use strict";
/**
 * Visibility API Response Types
 *
 * Response types for entity visibility operations:
 * archive, unarchive, make-public, make-private, and get-archived queries.
 *
 * Consumed by: free-pattern-warehouse-website (visibility fetchers)
 *
 * Backend handlers traced:
 * - lambda-secure/src/routes/patterns/archive-pattern.ts → { message, pattern_id }
 * - lambda-secure/src/routes/patterns/unarchive-pattern.ts → { message, pattern_id }
 * - lambda-secure/src/routes/patterns/make-pattern-public.ts → { message, pattern_id }
 * - lambda-secure/src/routes/patterns/make-pattern-private.ts → { message, pattern_id }
 * - lambda-secure/src/routes/patterns/get-archived-patterns.ts → { patterns }
 * - lambda-secure/src/routes/collections/management/archive-collection.ts → { message }
 * - lambda-secure/src/routes/collections/management/unarchive-collection.ts → { message, collection_id }
 * - lambda-secure/src/routes/collections/management/make-collection-public.ts → { message, collection_id }
 * - lambda-secure/src/routes/collections/management/make-collection-private.ts → { message, collection_id }
 *
 * NOTE: Collection visibility operations now use entity-specific types from collection.ts:
 *   ArchiveCollectionResponse, UnarchiveCollectionResponse, MakeCollectionPublicResponse, MakeCollectionPrivateResponse
 * - lambda-secure/src/routes/craft-room/projects/archive-project.ts → { message, project_id }
 * - lambda-secure/src/routes/craft-room/projects/unarchive-project.ts → { message, project_id }
 * - lambda-secure/src/routes/craft-room/projects/make-project-public.ts → { message, project_id }
 * - lambda-secure/src/routes/craft-room/projects/make-project-private.ts → { message, project_id }
 * - lambda-secure/src/routes/craft-room/materials/archive-material-v2.ts → { success }
 * - lambda-secure/src/routes/craft-room/materials/unarchive-material.ts → { success }
 * - lambda-secure/src/routes/craft-room/materials/make-material-public.ts → { message, material_id }
 * - lambda-secure/src/routes/craft-room/materials/make-material-private.ts → { message, material_id }
 * - lambda-secure/src/routes/craft-room/materials/get-archived-materials.ts → { materials, lastKey? }
 * - get-archived-projects / get-archived-collections: NO SUCH HANDLER, and none is coming — see below
 */
Object.defineProperty(exports, "__esModule", { value: true });
